import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import MenuItem from "@mui/material/MenuItem";
import * as React from "react";
import { ReactNode, useRef, useState } from "react";
import { Button, ButtonGroup, Menu } from "..";
import { ButtonGroupProps } from "@mui/material";

//const options = ["Create a merge commit", "Squash and merge", "Rebase and merge"];

export type MenuButtonOption = {
  label: string;
  action: () => void;
};

export const MenuButton = (
  props: ButtonGroupProps & {
    label: ReactNode;
    icon?: "ArrowDropDownIcon" | "ArrowDropDownCircleIcon"
    onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
    options: MenuButtonOption[];
  }
) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return (
    <ButtonGroup variant={props.variant || "text"} size={props.size}>
      <Button color="info" onClick={props.onClick} sx={{ paddingRight: "15px"}}>{props.label}</Button>

      <Button color="info" onClick={(e) => setAnchorEl(e.currentTarget)} sx={{ width: "15px" }} size="small">
        {!props.icon || props.icon == "ArrowDropDownIcon" && (<ArrowDropDownIcon />)}
        {props.icon && props.icon == "ArrowDropDownCircleIcon" && (<ArrowDropDownCircleIcon />)}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {props.options.map((option, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              option.action();
              setAnchorEl(null);
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </ButtonGroup>
  );
};
